import { getRouteFromPostType } from "~/lib/shared/getRouteFromPostType";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { SeriesIntroduction } from "~/types/asgard/SeriesIntroduction";
import { SeriesIntroductionCardProps } from "./SeriesIntroductionCard";

export const apiToSeriesIntroductionCardProps = (
  apiData: SeriesIntroduction
): SeriesIntroductionCardProps | null => {
  const introductionContentHTML = apiData?.introduction_body?.trim();
  const additionalStories = apiData?.additional_stories;

  if (!introductionContentHTML) {
    return null;
  }

  return {
    introductionContentHTML,
    introductionTitle: heDecodeOrDefault(apiData?.introduction_title?.trim()),
    additionalStories: additionalStories?.map((additionalStory) => {
      const additionalStoryTitle = additionalStory?.additional_story_title;
      const additionalStoryLink = getRouteFromPostType(
        additionalStory?.additional_story_link?.post_type,
        additionalStory?.additional_story_link?.post_name
      );

      const hasTitleAndLink =
        typeof additionalStoryTitle === "string" &&
        additionalStoryTitle.trim() &&
        typeof additionalStoryLink === "string";

      return {
        additionalStoryTitle: hasTitleAndLink
          ? heDecodeOrDefault(additionalStoryTitle.trim())
          : null,
        additionalStoryLink: hasTitleAndLink
          ? heDecodeOrDefault(additionalStoryLink.trim())
          : null,
      };
    }),
  };
};
